<div #wrapper class="shopping-list-wrapper">
    <app-modal-header [text]="'friends' | localise" [bold]="true" (close)="bsModalRef.hide()"></app-modal-header>

    <ng-container>
        <div class="modal-body" [ngClass]="isIOS() === true ? 'ios' : ''">
            <div class="list-wrapper shopping-list">
                <ul class="todo-list todo-list-custom">
                    <li *ngFor="let friend of friends;">
                        <div class="form-check form-check-flat">
                            <label class="form-check-label">
                                <input class="checkbox"
                                       (change)="checkFriend($event, friend.id)"
                                       type="checkbox" />
                                {{ friend.friend.first_name + ' ' + friend.friend.last_name }}
                                <i class="input-helper"></i>
                            </label>
                        </div>
                    </li>
                </ul>
            </div>

        </div>

        <div class="modal-footer" [ngClass]="isIOS() === true ? 'ios' : ''">
            <button type="button" class="btn btn-secondary"
                    (click)="bsModalRef.hide()">{{ 'back' | localise }}</button>
            <button type="button" class="btn btn-success" (click)="save()">{{ 'save' | localise }}</button>
        </div>
    </ng-container>
</div>
